<template>
  <div class="market-writeOffList-index">
    <Search :renderData="renderData" :formData="form" :labelWidth="110" @onSearch="onSearch" ></Search>
    <Table
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :loading="loading"
      :limit="limit"
      :total="total"
      :offset="offset"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
      <template #phone="{ row }">{{ row.phone }}</template>
      <template #name="{ row }">{{ row.name }}</template>
      <template #created="{ row }">{{ row.created ? $moment(row.created).format('YYYY/MM/DD HH:mm:ss') : '---' }}</template>
      <template #activityName="{ row }">{{ row.activityName }}</template>
      <template #type="{ row }">{{ row.type }}</template>
      <template #status="{ row }">
        <span v-if="row.status == 'WrittenOff'">已核销</span>
        <span v-if="row.status == 'UnwrittenOff'">待核销</span>
        <span v-if="row.status == 'Expired'">已过期</span>
      </template>
      <template #source="{ row }">{{ row.source }}</template>
      <!-- <template #operation="{ scope }">
        <el-button v-if="scope.row.status == 'UnwrittenOff'" type="text" @click="onWriteOff(scope.row)">核销</el-button>
      </template> -->
    </Table>
  </div>
</template>

<script>
import tableList from '@/mixins/tableList'
import { api_getWriteOffList } from '@/api/market'
import { api_getConfig } from '@/api/common'
import Search from "@/components/Search/index";
import Table from "@/components/Table/index";
export default {
  name: "marketWriteOffListIndex",
  mixins: [ tableList ],
  components: {
    Search,
    Table,
  },
  data() {
    return {
      renderData: [
        {
          label: "中奖会员手机号",
          placeholder: "请输入中奖会员手机号",
          type: "input",
          key: "phone",
          isNumber: true,
          maxLength: 11
        },
        {
          label: "核销状态",
          placeholder: "请选择核销状态",
          type: "select",
          key: "status",
          option: [
            {label: '已核销', value: 'WrittenOff'},
            {label: '待核销', value: 'UnwrittenOff'},
            {label: '已过期', value: 'Expired'},
          ]
        },
      ],
      form: {},
      tableThData: [
        { prop: "phone", label: "中奖会员手机号", minWidth: "180", },
        { prop: "name", label: "中奖奖品", minWidth: "180", },
        { prop: "created", label: "中奖时间", minWidth: "180", },
        { prop: "activityName", label: "活动名称", minWidth: "180", },
        { prop: "type", label: "活动类型", minWidth: "180", },
        { prop: "status", label: "核销状态", minWidth: "180", },
        { prop: "source", label: "核销来源", minWidth: "180", },
        // { prop: "operation", label: "操作", minWidth: "150", },
      ],

      couponTypeDataObj: {}, // 优惠券类型obj数据
      useRangeTypeDataObj: {
        'Generic': '通用',
        'Mall': '指定商场可用',
        'Store': '指定店铺可用',
      }, // 使用范围obj数据
    };
  },
  created () {
    this.getCouponTypeData() // 获取优惠券类型数据
  },
  methods: {
    // 获取表格列表数据
    async getList () {
      this.loading = true
      const params = {
        ...this.form,
        offset: this.offset,
        limit: this.limit,
      }
      this.$router.push({query: params})
      const data = await api_getWriteOffList(params)
      console.log('data: ', data);
      this.tableTrData = data.list || []
      this.total = data.count
      this.loading = false
    },

    // 获取优惠券类型数据
    async getCouponTypeData() {
      const {couponType=[]} = await api_getConfig(['couponType'])
      let couponTypeObj = {}
      couponType.map(item => {
        couponTypeObj[item.name] = item.desc
      })

      this.couponTypeDataObj = couponTypeObj
    },

    // 点击核销
    // onWriteOff(row) {
    //   this.$baseConfirm(
    //     '是否核销该奖品？',
    //     { title: '提示', type: 'warning', },
    //     async () => {
    //       this.$baseMessage('操作成功', 'success')
    //       this.getList()
    //     }
    //   )
    // },

  },
  watch: {
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.market-writeOffList-index {
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;

  .status{
    width: 6px;
    height: 6px;
    display: inline-block;
    border-radius: 50%;
    vertical-align: middle;
  }
  .dot-success{
    background: #05c8af;
  }

  .dot-clear {
    background: #F74A4A;
  }

  .dot-ing {
    background: #3775FF;
  }

  .dot-new {
    background: #ccc;
  }
}
</style>
